var _rect, _rect2, _path, _path2, _circle, _rect3, _path3, _path4, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 266,
    height: 266,
    fill: "#DEF2F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 94.9609,
    width: 123.147,
    height: 86.4651,
    transform: "rotate(-11.0177 48 94.9609)",
    fill: "#DEF2F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.877 71.4261L48 94.9609L64.5245 179.832L185.402 156.297L168.877 71.4261ZM160.595 83.7172L60.2922 103.246L72.8108 167.543L173.113 148.014L160.595 83.7172Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4486 136.498L82.5753 142.284L84.4531 151.929L156.465 137.908L153.461 122.477L138.616 111.353L129.813 124.412L102.928 106.289L81.4486 136.498Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 125.018,
    cy: 106.66,
    r: 5.24031,
    transform: "rotate(-11.0177 125.018 106.66)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93.8535,
    y: 108.104,
    width: 123.147,
    height: 86.4651,
    fill: "#DEF2F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.003 108.104H93.8555V194.569H217.003V108.104ZM206.522 118.584H104.336V184.088H206.522V118.584Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.744 155.267V161.163V170.988H192.108V155.267L179.663 141.511L168.527 152.647L145.601 129.721L118.744 155.267Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.219,
    cy: 134.305,
    r: 5.24031,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.def7e1ba758f02bf0afe02afadaae8dc.svg";
export { ForwardRef as ReactComponent };